import { AlertTriangle, Home, RefreshCw } from 'lucide-react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

export function RouteErrorPage() {
  const error = useRouteError()
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error ? error.message : 'Error inesperado de interfaz'

  return <main className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
    <section className="w-full max-w-lg rounded-2xl border bg-white p-8 text-center shadow-sm">
      <AlertTriangle className="mx-auto h-10 w-10 text-amber-500" />
      <h1 className="mt-4 text-xl font-semibold">No pudimos mostrar esta pantalla</h1>
      <p className="mt-2 text-sm text-slate-600">Tus datos no se modificaron. Podés reintentar o volver al inicio.</p>
      <details className="mt-4 rounded-lg bg-slate-100 p-3 text-left text-xs text-slate-600"><summary className="cursor-pointer font-medium">Detalle técnico</summary><p className="mt-2 break-words">{detail}</p></details>
      <div className="mt-6 flex justify-center gap-3"><button onClick={() => window.location.reload()} className="flex items-center gap-2 rounded-lg bg-violet-600 px-4 py-2 text-sm text-white"><RefreshCw className="h-4 w-4" />Reintentar</button><a href="/" className="flex items-center gap-2 rounded-lg border px-4 py-2 text-sm"><Home className="h-4 w-4" />Inicio</a></div>
    </section>
  </main>
}
